
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody:{
              "thirdBillCode": "2023051114363066769660"
            },
            responseCode: {
              "data": {
                "dataList": [
                  {
                    "billCode": "123123",
                    "billType": 0,
                    "invoiceValue": 5.00,
                    "isOpened": 5,
                    "parkCode": "2K132123",
                    "thirdBillCode": "42000028352025081123123123"
                  }
                ]
              },
              "message": "业务成功",
              "resultCode": 0,
              "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 根据第三方交易号获取账单",
                t_url: this.commonUrls.test + "getBillInvoiceDetail",
                p_url: this.commonUrls.prod + "getBillInvoiceDetail",
                precondition: "查询车场支付账单后调用，平台存在的账单",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方账单流水号' },
                        { info1: 'payTimeStart', info2: '是', info3: 'String', info4: '支付开始时间 yyyyMMddHHmmss 时间间隔不能超过3个月' },
                        { info1: 'payTimeEnd', info2: '是', info3: 'String', info4: '支付结束时间 yyyyMMddHHmmss 时间间隔不能超过3个月' },
                    ]
                }],
                R_params: [{
                  titleName: null,
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'dataList', info2: '是', info3: 'String', info4: '账单列表' },
                  ]
                },{
                    titleName: "dataList",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方账单流水号' },
                      { info1: 'invoiceValue', info2: '是', info3: 'String', info4: '发票金额' },
                      { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                      { info1: 'billType', info2: '是', info3: 'Integer', info4: '(发票项目)账单类型 0停车费, 2月票 ' },
                      { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
                      { info1: 'isOpened', info2: '是', info3: 'Integer', info4: '开票状态1已开，0未开' },
                  ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/invoice/getBillInvoiceDetail.vue